export default {
  rowActionFlags: ['rowSelection'],
  types: {
    BASE: 'base',
    DISPLAY: 'display',
    SETTINGS: 'settings'
  },
  resultTableFlags: ['selectableRows'],
  components: {
    LINK: 'link',
    STATIC_FIELD: 'staticField',
    INPUT: 'input',
    ICON: 'icon',
    BUTTON: 'button',
    STATUS_BADGE: 'statusBadge',
    RADIO: 'radio',
    CHECKBOX: 'checkbox',
    COMBOBOX: 'combobox',
    DROPDOWN: 'dropdown',
    ACTIVE_FILTER: 'activeFilter',
    FILTER_INPUT: 'filterInput',
    FILTER_INPUT_TEXT:'filterInputText',
    FILTER_INPUT_NUMBER:'filterInputNumber',
    // FILTER
    FILTER_DROPDOWN: 'filterDropdown',
    ICON_MENU: 'menu'
  }
};
